import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AgendaComponent } from './components/agenda/agenda.component';
import { routing, appRoutingProviders } from './app.routing';
import { ConfirmationComponent } from './components/confirmation.component';
import { ErrorComponent } from './components/error.component';
import { ReportsComponent } from './components/reports.component';
import { ReportscmComponent } from './components/reportscm.component';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { AgendaProComponent } from './components/agendapro.component';
import { FeedbackProComponent } from './components/feedback.component';
import { GarantiaComponent } from './components/garantia.component';
import { ReportAgendaProComponent } from './components/reportAgendaPro.component';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { EncuestaComponent } from './components/encuesta.component';
import { ReportEncuestaComponent } from './components/reportEncuesta.component';
import { LandingComponent } from './components/landing.component';
import { JwtInterceptor } from './services/jwtInterceptor.service';
import { AutocompleteComponent } from './components/google-places.component';
import { TooltipModule } from 'primeng/tooltip';
import { AgendaCoComponent } from './components/agenda-co/agenda-co.component';

@NgModule({
  declarations: [
    AppComponent,
    AgendaComponent,
    ConfirmationComponent,
    ErrorComponent,
    ReportsComponent,
    ReportscmComponent,
    AgendaProComponent,
    FeedbackProComponent,
    GarantiaComponent,
    ReportAgendaProComponent,
    EncuestaComponent,
    ReportEncuestaComponent,
    LandingComponent,
    AutocompleteComponent,
    AgendaCoComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    routing,
    FormsModule,
    CalendarModule,
    TableModule,
    DropdownModule,
    AccordionModule,
    CardModule,
    MultiSelectModule,
    CheckboxModule,
    TooltipModule
  ],
  providers: [appRoutingProviders,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
